import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { getWeek, isSameWeek } from '@/utils/date';

import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import ArrowRightIcon from '@/assets/icons/arrow-right.svg?react';
import { useTypedDispatch } from '@/store';
import { setTasks } from '@/store/tasks';

const WeekNavigation = () => {
  const history = useNavigate();
  const { dayInMs } = useParams();
  const [t] = useTranslation();
  const dispatch = useTypedDispatch();

  const weekInterval = useMemo(() => {
    const currentWeek = getWeek('current', +dayInMs);
    if (isSameWeek(currentWeek[0], new Date())) {
      return t('thisWeek');
    }
    return `${currentWeek[0].format('DD.MM')} - ${currentWeek[6].format('DD.MM')}`;
  }, [dayInMs, t]);

  const onPressPrev = () => {
    dispatch(setTasks([]));
    const previousMonday = getWeek('previous', +dayInMs)[0].valueOf();
    history(`/week/${previousMonday}`);
  };

  const onPressNext = () => {
    dispatch(setTasks([]));
    const nextMonday = getWeek('next', +dayInMs)[0].valueOf();
    history(`/week/${nextMonday}`);
  };

  const goToToday = () => {
    dispatch(setTasks([]));
    history(`/week/${new Date().getTime()}`);
  };

  const onCalendarClick = (date: Date | null) => {
    if (date) {
      dispatch(setTasks([]));
      history(`/week/${date.getTime()}`);
    }
  };

  return (
    <div className="navigation">
      <div className="navigation__dates">
        <div className="navigation__arrow" onClick={onPressPrev}>
          <ArrowLeftIcon />
        </div>
        <div className="navigation__current-week">{weekInterval}</div>
        <div className="navigation__calendar">
          <DatePicker
            calendarClassName="green-theme-calendar"
            dayClassName={() => "green-theme-day"}
            selected={dayjs(+dayInMs).toDate()}
            onChange={onCalendarClick}
            dateFormat="dd.MM.yyyy"
            popperPlacement="bottom-start"
            customInput={<div className="datepicker-calendar"/>}
            showPopperArrow={false}
            onClickOutside={(e) => {
              e.preventDefault();
            }}
            shouldCloseOnSelect={true}
          />
        </div>
        <div className="navigation__arrow" onClick={onPressNext}>
          <ArrowRightIcon />
        </div>
      </div>
      {!isSameWeek(getWeek('current', +dayInMs)[0], new Date()) && (
        <h2 className="navigation__today" onClick={goToToday}>
          {t('today')}
        </h2>
      )}
    </div>
  );
};

export default WeekNavigation;
